export default __webpack_public_path__ + "static/media/title_ko_pc@2x.73c3c387.png";